import * as React from 'react';
import { RouteType } from '../types/route.types';
import { Supplier } from '../components/supplier/supplier';
import { PowerBI } from '../components/powerbi/powerbi';
import { RuleEngine } from '../components/materialRuleAndVerificationRoutine/ruleEngine';
import { MaterialPlatform } from '../components/materialPlatform/materialPlatform';
import { ControlUnion } from '../components/contolUnion/controlUnion';
import { Home } from '../components/home/home';

export const routes: RouteType[] = [
	{
		path: '/',
		element: <Home />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? true : false,
	},
	{
		path: '/supplier',
		element: <Supplier />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? false : true,
	},
	{
		path: '/material',
		element: <MaterialPlatform />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? true : false,
	},
	{
		path: '/ruleengine',
		element: <RuleEngine />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? true : false,
	},
	{
		path: '/brandCertification',
		element: <ControlUnion />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? true : false,
	},
	{
		path: '/powerbi',
		element: <PowerBI />,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? false: true,
	},
	{
		path: '/user',
		element: <></>,
		isVisibleForSupplier: localStorage.getItem('isSupplierAccount') === 'true' ? true: false,
	},
];
